/* istanbul ignore file */
import { array as codecArray, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { FileTreeFileItem } from './FileTreeFileItem';
const FileTreeDirectoryItemParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('dir')],
    ['name', codecString],
    [
        'entries',
        /* #__PURE__ */ parsers.lazy(() => 
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['file', FileTreeFileItem],
            ['dir', FileTreeDirectoryItem],
        ]))),
    ],
]);
export class FileTreeDirectoryItem extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return FileTreeDirectoryItemParser.decode(input).map(res => new FileTreeDirectoryItem(res));
    }
    static unsafeDecode(input) {
        return FileTreeDirectoryItem.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FileTreeDirectoryItemParser.encode(data);
    }
    static schema() {
        return FileTreeDirectoryItemParser.schema();
    }
}
